var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lb-ad",class:!_vm.adSwitch ? 'ad-collapse' : ''},[_c('div',{staticClass:"ad-main"}),_vm._v(" "),_c('div',{staticClass:"flod",on:{"click":_vm.handleFold}},[_vm._v(_vm._s(_vm.adSwitch ? '折叠' : '展开'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27577211","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ad.vue
// module id = null
// module chunks = 